import React from 'react'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

import {RoomLabelsAndCashbackWrapper} from './shared'

interface UseCashbackPositioningProps {
  cashbackComponent?: React.ReactNode
  roomLabelsComponent?: React.ReactNode
  lineBreak?: boolean
}

export const useCashbackPositioning = ({
  cashbackComponent,
  roomLabelsComponent,
  lineBreak = false
}: UseCashbackPositioningProps) => {
  const {
    monetisation: {cashback, hasEarnedPoints}
  } = useBrandCapabilities()
  const isLongMessageLayout = cashback.enabled
    ? cashback.config.isLongMessageLayout
    : hasEarnedPoints

  // Return null if no cashbackComponent, otherwise return component or null based on brand
  const showCashbackOnLeft =
    isLongMessageLayout && cashbackComponent ? cashbackComponent : null
  const showCashbackOnRight =
    !isLongMessageLayout && cashbackComponent ? cashbackComponent : null

  const renderRoomLabelsWithCashback = () => {
    if (showCashbackOnLeft && roomLabelsComponent) {
      return (
        <RoomLabelsAndCashbackWrapper lineBreak={lineBreak}>
          {roomLabelsComponent}
          {showCashbackOnLeft}
        </RoomLabelsAndCashbackWrapper>
      )
    }

    return (
      <>
        {roomLabelsComponent}
        {showCashbackOnLeft}
      </>
    )
  }

  return {
    showCashbackOnLeft,
    showCashbackOnRight,
    renderRoomLabelsWithCashback
  }
}
